var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLifestyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20166 14.7691C1.20166 14.7691 2.30618 11.8479 3.679 10.49C5.52656 8.66248 8.09367 8.9127 9.72587 7.52365C10.8054 6.60498 12.3654 4.56016 13.2982 3.28062C13.6962 2.73466 14.5019 2.72632 14.7911 3.3369C15.0227 3.82573 15.2222 4.41205 15.2222 4.98145C15.2222 5.50144 15.1224 5.92886 14.9993 6.25829C14.8155 6.75012 14.8194 7.36339 15.1767 7.74813L16.8425 9.54207C17.1851 9.91101 17.1521 10.4908 16.7698 10.8185L16.7496 10.8358C16.4735 11.0725 16.3787 11.4586 16.5137 11.7963L16.5319 11.8416C16.6554 12.1505 16.5697 12.5038 16.3183 12.7217V12.7217C16.0647 12.9415 15.9799 13.2988 16.1076 13.6091L16.1528 13.7188C16.2399 13.9302 16.2474 14.1661 16.1739 14.3827L15.8937 15.2084M8.1238 18.8889L12.1686 17.1398C12.2494 17.1049 12.3344 17.0808 12.4214 17.0681L13.5998 16.8965L14.089 16.8252",
    stroke: "#666666",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9738,
    cy: 18.3334,
    r: 1.66667,
    fill: "#F7E237"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80228 7.44775C9.47441 7.77924 7.93881 9.88209 6.83596 11.8212C5.91943 13.4327 5.88522 16.9172 0.833496 17.8187",
    stroke: "#666666",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00578 1.94434C7.00578 1.94434 5.18074 2.04026 3.59026 3.31265C1.99978 4.58503 1.59694 6.82235 0.833496 7.07683",
    stroke: "#666666",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLifestyle);
export default __webpack_public_path__ + "static/media/search_lifestyle.21b4c5510c556f9afc89963c2b4fcb9c.svg";
export { ForwardRef as ReactComponent };